import { SIZE_TYPE, SIZES } from './getFormattedGoogleImages';

export function getQuality(dimension) {
  return dimension > SIZES[SIZE_TYPE.SMALL]
    ? SIZE_TYPE.MEDIUM
    : SIZE_TYPE.SMALL;
}
